import axios from 'axios'
import Conf from 'ui-config'
//Conf.HOST_S + Conf.LC_IP +
const WorkbookService = {
  vField: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/vfields', params, {
      headers: {
        SSID: ssid,
      },
    })
  },

  // Workbook Volume Data API
  getVolumeOfData: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/job/realtimecost',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getOutlierRecommendation: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST +
        Conf.CORE_IP2 +
        Conf.PORT_3 +
        '/' +
        clusterId +
        '/wrk/api/outlier/recommendations',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getWorkbookMeta: function(ssid, clusterId, type) {
    return axios.get(Conf.HOST + Conf.LC_IP + '/' + clusterId + `/api/workbook/meta?type=${type}`, {
      headers: {
        SSID: ssid,
      },
    })
  },

  getTagsFIlter: function(ssid, clusterId, params, type) {
    return axios.post(
      Conf.HOST +
        Conf.LC_IP +
        '/' +
        clusterId +
        '/api/signals/tag/' +
        `${type === 'create' ? 'create' : 'list'}`,
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getSignalTacticTech: function(params, type, ssid, clusterId) {
    if (type === 'tactic') {
      return axios.get(
        Conf.HOST + Conf.CORE_IP2 + Conf.PORT_3 + '/' + clusterId + '/wrk/api/attack/matrix',
        {
          headers: {
            SSID: ssid,
          },
        },
      )
    } else {
      return axios.post(
        Conf.HOST + Conf.CORE_IP2 + Conf.PORT_3 + '/' + clusterId + '/wrk/api/attack/matrix',
        params,
        {
          headers: {
            SSID: ssid,
          },
        },
      )
    }
  },
  getStreams: function(params, clusterId) {
    return axios.get(
      Conf.HOST +
        Conf.CORE_IP2 +
        Conf.PORT_3 +
        '/' +
        clusterId +
        '/mgmt/core/stream-management/?scope_id=' +
        params.scopeId +
        '&search_type=' +
        params.search_type,
      {
        headers: {
          SSID: params.ssid,
        },
      },
    )
  },
  getSourceNameArr: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/source_name', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  getActiveStreams: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.CORE_IP2 + Conf.PORT_3 + '/' + clusterId + '/mgmt/core/daily-stream-details',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getSignalStreamStatus: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.CORE_IP2 + Conf.PORT_3 + '/' + clusterId + '/mgmt/core/signal-stream-status',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  DownloadCurrentWb: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/download',
      params,
      {
        headers: {
          SSID: ssid,
        },
        responseType: 'blob',
      },
    )
  },
  AddnewWorkbook: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/add', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  getWorkboookList: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/list',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getWorkbookStreamsList: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/wbstreamdryflow',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  deleteWorkbook: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/delete',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  removeSimulationFile: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/removesimulationfile',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  moveWorkbook: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/move',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getProperties: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/properties',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  EditWorkbook: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/workbook/edit',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  searchWorkbook: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/search', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  executeWorkbook: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.CORE_IP2 + Conf.PORT_3 + '/' + clusterId + '/wrk/api/job/invoke',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  DirectoryList: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/directory/list',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  addDirectory: function(param, ssid, clusterId) {
    return axios.post(Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/directory/add', param, {
      headers: {
        SSID: ssid,
      },
    })
  },
  deleteDirectory: function(param, ssid, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/directory/delete',
      param,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  eventStoreList: function(params, clusterId) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/event_store/list',
      params,
      {
        headers: {
          SSID: window.$ssid,
        },
      },
    )
  },

  timeZoneList: function(ssid, clusterId) {
    return axios.get(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/timezones', {
      headers: {
        SSID: ssid,
      },
    })
  },
  streamAnalytics: function(ssid, params, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/stream/analytics',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getSubtechniuqesDetails: function(ssid, clusterId, params) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/get_mitre_technique_data',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getWorkbookSignalCount: function(ssid, clusterId, params) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/wrk/api/attack/get_workbook_signal_count',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getSubtechniqueData: function(params, ssid, clusterID) {
    if (params !== '') {
      return axios.post(
        Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/api/models/get_subtechnique_data',
        params,
        {
          headers: {
            SSID: ssid,
          },
        },
      )
    } else {
      return axios.get(
        Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/api/models/get_subtechnique_data',
        {
          headers: {
            SSID: ssid,
          },
        },
      )
    }
  },
  streamSignals: function(ssid, params, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/signals/timeslice_data',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  exportWorkbooks: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/entity/download', params, {
      responseType: 'blob',
      headers: {
        // 'Content-type': params.download_dict_info.workbooks.length > 1 ? 'application/x-tar' : '',
        'Content-type': 'application/x-tar',
        SSID: ssid,
      },
    })
  },
  errorOnExportWorkbooks: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/entity/download', params, {
      headers: {
        // 'Content-type': params.download_dict_info.workbooks.length > 1 ? 'application/x-tar' : '',
        'Content-type': 'application/x-tar',
        SSID: ssid,
      },
    })
  },
  importWorkbooks: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/entity/upload', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
        SSID: ssid,
        // Connection: 'keep-alive',
      },
    })
  },
  enableDisableWorkbooks: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/workbook/visibility',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  lockUnlockWorkbooks: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/workbook/lock_unlock',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getWorkbookVersionList: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/workbook/versionlist',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  revertWorkbookToVersionNumber: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/workbook/versionrevert',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getWorkBookVersionDetails: function(params, ssid, clusterId) {
    return axios.post(
      Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/workbook/versionview',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getSignalTagsList: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/signals/tag/list', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  RecipientList: function(params, clusterID, ssid) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/wrk/api/recipients',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  WorkbookRecipientList: function(params, clusterID, ssid) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/mgmt/cluster-user/user-list',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getSavedWorkbookAttribution: function(params, clusterID, ssid) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/api/models/get_workbook_attribution_data',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  generateWorkbookAttribution: function(params, clusterID, ssid) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/api/models/workbook_attribution',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  checkWorkbookChange: function(params, clusterID, ssid) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/api/detect/workbook_updates',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getJobStatus: async function(params, ssid, clusterId) {
    return await axios.get(
      Conf.HOST +
        Conf.CORE_IP +
        Conf.PORT_3 +
        '/' +
        clusterId +
        '/wrk/api/dispatcher/task/state/' +
        params.taskid,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getJobResult: async function(params, ssid, clusterId) {
    return await axios.get(
      Conf.HOST +
        Conf.CORE_IP +
        Conf.PORT_3 +
        '/' +
        clusterId +
        '/wrk/api/dispatcher/task/result/' +
        params.taskid,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },
  getModelUsageData: function(params, ssid, clusterID) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/wrk/api/model_usage_data',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  generateWorkbookDocumentation: function(params, ssid, clusterID) {
    return axios.post(
      Conf.HOST_S +
        Conf.CORE_IP2 +
        '/' +
        clusterID +
        '/api/models/workbook_documentation_generator',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getWorkbookDocumentData: function(params, clusterID, ssid) {
    return axios.post(
      Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterID + '/api/models/get_workbook_kb_data',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  // removeCustomTag: function(params, ssid, clusterId) {
  //   return axios.post(Conf.HOST + Conf.LC_IP + '/' + clusterId + '/api/signals/tag/remove', params, {
  //     headers: {
  //       SSID: ssid,
  //     },
  //   })
  // },
}

export default WorkbookService
